// extracted by mini-css-extract-plugin
module.exports = {"grid__switch":"grid__switch___3joMM","grid__switch__option":"grid__switch__option___15QBu","is-active":"is-active___1eezZ"};